exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media print {\npre, blockquote,p,dive {page-break-inside: auto;}\n}\ndiv#prescriptionFooterNote1 table {\n  width: 100%;\n}\n.prescriptionFooterNotehold table tbody{border: none;}\n#symp-body .doctor-summary p { display: inline; margin: 0;\n}\n", ""]);

// exports
